

import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogContent, DialogTitle, Icon } from '@mui/material'
import { PaperArrastavel } from 'app/components/dialog-arrastavel/PaperArrastavel'
import { IColuna } from 'app/types/IColuna'
import clsx from 'clsx'
import React, { useState } from 'react'


export type AcoesHeadAtendimentoProps = {
    onAlterarFonte?: (tamanho: number) => void
    colunas: IColuna[],
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void
    tamanhoFonte: number
    exibirIconesAumentarDiminuirFonte?: boolean
    larguraLinha?: number
    permiteEngrenagemGrid?: boolean // 4185064
}

const _NOME_PARA_CABECALHO_MAP: Record<string, string> = {
    "DataProximoContato": "Próximo Contato",
}

const traduzirNomeColuna = (nomeColuna: string) =>
    nomeColuna in _NOME_PARA_CABECALHO_MAP ? _NOME_PARA_CABECALHO_MAP[nomeColuna] : nomeColuna

export const AcoesHeadAtendimento = (props: AcoesHeadAtendimentoProps) => {
    const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false)
    const [icon, setIcon] = useState<string>('arrow_drop_up')

    const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false)


    const selecaoDeColunas = <div className="_grid _grid-cols-1 _grid-flow-row">

        <div className="_flex _flex-row _justify-start _max-w-xs _items-end">
            <div className="_mr-4">
                <input
                    type="checkbox"
                    id="AcoesHeadAtendimento_SelecionarTodasColunasCheckbox"
                    checked={props.colunas.every(c => c.Selecionada == true)}
                    onChange={e => props.onToggleSelecionarTodasColunas(e.target.checked)} />
            </div>

            <b>Todas</b>

        </div>

        {props.colunas.map(coluna => <div
            className="_flex _flex-row _justify-start _max-w-xs _items-end"
            key={coluna.Nome}>

            <div className="_mr-4">
                <input
                    id={`AcoesHeadAtendimento_Coluna${coluna.Nome}Checkbox`}
                    type="checkbox"
                    checked={coluna.Selecionada ?? false}
                    onChange={() => props.onToggleColunaSelecionada(coluna.Nome, !coluna.Selecionada)} />
            </div>

            {traduzirNomeColuna(coluna.Nome)}
        </div>)}
    </div>

    const selecaoDeColunasDialog = <Dialog open={exibirSelecaoColunas} onClose={() => setExibirSelecaoDeColunas(false)} PaperComponent={PaperArrastavel}>
        <DialogTitle>
            Selecionar colunas para exibição
        </DialogTitle>
        <DialogContent>
            {selecaoDeColunas}
        </DialogContent>
    </Dialog>

    const botoes = <div style={{
        width: props.larguraLinha != undefined ? `${props.larguraLinha}px` : undefined

    }} className="_flex _flex-row _mt-4 _gap-x-2 _bg-[#daddde] _p-[5px]">

        {(props.permiteEngrenagemGrid ?? false) && <>
            <FontAwesomeIcon icon={faGear} className="_text-2xl _cursor-pointer" onClick={() => setExibirSelecaoDeColunas(true)} />
        </>}


        {(props.exibirIconesAumentarDiminuirFonte ?? true) && <>
            <button
                className="no-global-button _bg-white _p-[5px] _rounded-[3px]"
                onClick={() => props.onAlterarFonte?.(props.tamanhoFonte + 1)}
                disabled={props.tamanhoFonte >= 26}

            >A+
            </button>
            <button
                className="no-global-button _bg-white _p-[5px] _rounded-[3px]"
                onClick={() => props.onAlterarFonte?.(props.tamanhoFonte - 1)}
                disabled={props.tamanhoFonte <= 8}

            >A-
            </button></>}
    </div>

    const iconeExibirEsconderOpcoes = (
        <button
            style={{ marginLeft: '14px', height: '20px' }}
            id="table-headgrid-itensarrow"
            className="no-global-button"
            onClick={() => {
                setMostrarFerramentas(!mostrarFerramentas);
                setIcon(icon == "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up");
            }}
        >
            <Icon>{icon}</Icon>
        </button>
    );

    return <>
        <div className='_bg-[#daddde] _flex _flex-col _items-start'>
            {iconeExibirEsconderOpcoes}
            {mostrarFerramentas && (
                <section>
                    {botoes}
                </section>
            )}
        </div>

        {exibirSelecaoColunas && selecaoDeColunasDialog}
    </>
}
